import {useContext} from 'react';
import {OrderViewContext} from "./OrderViewContext";
import TabulatorTableOptions from "../../utils/TabulatorTableOptions";
import {ReactTabulator} from "react-tabulator";
import NewTabulator from "../NewTabulator/NewTabulator";
import "./style.scss"
import NewTabulator1 from "../NewTabulator1/NewTabulator1";
import {useNavigate} from "react-router-dom";


function TableSectionOrderView(props) {
  const helper = useContext(OrderViewContext);
  const setData = helper.setData
  const data = helper.data

  const navigateTo = useNavigate()

  const options = {
    // layout: 'fitColumns',
    // headerVertical: 'middle', // Center align header text vertically
    //cellVertical: 'middle',   // Center align data text vertically
  };

  const handleRowClick=(cell)=>{
    console.log(cell);
    setData({selectedRowId:cell.orderId})
  }
  try {
    return (<div style={{
      "height": '60vh',
      overflow: 'scroll'}}
                 className={"mt-5"}
    >
      <NewTabulator1
        columns={data?.tableData?.columns}
        data={data?.tableData?.data}

        style={{height: '53vh', overflow: 'scroll' , width:'fit-content'}}
        className={"header__orderView__table "}
        events={{
          // rowClick: handleRowClick,
          pagination: true,
          paginationPageSize: 10,
          onDataChange: (newData) => setData({currentTableData: newData})
        }}

      />


      {/*<ReactTabulator*/}
      {/*  columns={data?.tableData?.columns}*/}
      {/*  data={data?.tableData?.data}*/}
      {/*   events={}*/}
      {/*   className={"header__costBenefit2__table "}*/}
      {/*   options={TabulatorTableOptions.style1}*/}
      {/*/>*/}
    </div>);
  } catch (error) {
    console.log(error)
    return <>{error.toString()}</>
  }
}

export default TableSectionOrderView;